/**
 * Created by Ivan on 13.03.2026
 */

class FullScreenComponent extends BaseComponent {
    onCreate() {
        this.view = PrefabBuilder.resolveProperty(this.options.view, this.context);

        this.view.withShadow = true;
    }

    onAttach() {
        const bg = this.findDirectChild("bg");
        if (bg) {
            this.bgContentSize = bg.getContentSize();
            this.node.setContentSize(this.bgContentSize);
        }

        this.onResize();
    }

    onResize() {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const bgSize = cleverapps.resolution.getBgSize();
        const bgRect = cleverapps.resolution.getBgRect();

        this.view.setContentSize(sceneSize.width, sceneSize.height);
        this.view.setPosition(sceneSize.width / 2, sceneSize.height / 2);

        this.node.setContentSize(sceneSize.width, sceneSize.height);
        this.node.setPosition(this.view.width / 2, this.view.height / 2);

        const bg = this.findDirectChild("bg");
        if (bg) {
            bg.setScale(Math.max(bgSize.width / this.bgContentSize.width, bgSize.height / this.bgContentSize.height));
            bg.setPosition(bgRect.x + bgRect.width / 2, bgRect.y + bgRect.height / 2);
        }

        const frame = this.findDirectChild("frame");
        if (frame) {
            frame.setContentSize(bgRect.width, bgRect.height);
            frame.setPosition(bgRect.x + bgRect.width / 2, bgRect.y + bgRect.height / 2);
        }
    }

    findDirectChild(name) {
        return this.node.children.find((child) => child.getName() === name);
    }
}

Prefab.registerComponent("FullScreenComponent", FullScreenComponent);
